import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import visionLogo from "../../../assets/img/logo-vision.png";
import amerinodeLogo from "../../../assets/img/logo-amerinode.jpeg";
import { useForm } from "react-hook-form";
import CompanyService from "../../../services/CompanyService"

// Context
import { Context } from "../../../context/UserContext";
import Estados from "../../../enums/Estados";

function Register() {

  const { createUser } = useContext(Context)

  const [companiesList, setCompaniesList] = useState([])

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({defaultValues: {
    // name: 'Teste',
  }});

  const onSubmit = (data) => {
    // console.log(data)
    createUser(data)
  };

  const watchPassword = watch('password')

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value)

  }

  const navigate = useNavigate();

  // const estados = [
  //   { nome: "Acre", sigla: "AC" },
  //   { nome: "Alagoas", sigla: "AL" },
  //   { nome: "Amapá", sigla: "AP" },
  //   { nome: "Amazonas", sigla: "AM" },
  //   { nome: "Bahia", sigla: "BA" },
  //   { nome: "Ceará", sigla: "CE" },
  //   { nome: "Distrito Federal", sigla: "DF" },
  //   { nome: "Espírito Santo", sigla: "ES" },
  //   { nome: "Goiás", sigla: "GO" },
  //   { nome: "Maranhão", sigla: "MA" },
  //   { nome: "Mato Grosso", sigla: "MT" },
  //   { nome: "Mato Grosso do Sul", sigla: "MS" },
  //   { nome: "Minas Gerais", sigla: "MG" },
  //   { nome: "Pará", sigla: "PA" },
  //   { nome: "Paraíba", sigla: "PB" },
  //   { nome: "Paraná", sigla: "PR" },
  //   { nome: "Pernambuco", sigla: "PE" },
  //   { nome: "Piauí", sigla: "PI" },
  //   { nome: "Rio de Janeiro", sigla: "RJ" },
  //   { nome: "Rio Grande do Norte", sigla: "RN" },
  //   { nome: "Rio Grande do Sul", sigla: "RS" },
  //   { nome: "Rondônia", sigla: "RO" },
  //   { nome: "Roraima", sigla: "RR" },
  //   { nome: "Santa Catarina", sigla: "SC" },
  //   { nome: "São Paulo", sigla: "SP" },
  //   { nome: "Sergipe", sigla: "SE" },
  //   { nome: "Tocantins", sigla: "TO" },
  // ];


  useEffect(()=>{

    const fetchData = async () =>{
      const result = await CompanyService.getCompanies();      
      setCompaniesList(result.companies)
    }
    fetchData();   

  }, []);

  // const handleLogin = () => {
  //   navigate('/app');
  // }

  return (
  <>
    

{/* NOVO */}
    <div className="flex flex-col justify-between items-center min-h-screen bg-neutral-100">

      <div className="flex flex-1 w-full">
        {/* LEFT */}
        <div className="min-w-[600px] flex flex-col justify-center items-center bg-white rounded-lg m-20 py-4">
        
        <div className="w-full flex flex-col justify-center items-center px-20 mt-3 z-10 gap-8">
          <div className="flex justify-center text-3xl font-semibold whitespace-nowrap">
            Cadastrar Usuário
          </div>

          <div className="min-w-96 flex flex-col gap-3">
            <div className="flex items-center justify-between gap-2">
              <label className="w-1/4 block text-sm font-medium text-gray-900">
                Nome:
              </label>
              <div className="w-full">
                <input
                  {...register("name", { required: true })}
                  type="text"
                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                    ${
                      errors?.name?.type === "required" ?
                      " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                    }
                    `}
                />
                {errors?.name?.type === "required" && (
                  <p className="text-red-500 text-xs ms-2">
                    Nome é obrigatório
                  </p>
                )}
              </div>
            </div>

            <div className="flex items-center justify-between gap-2">
              <label className="w-1/4 block text-sm font-medium text-gray-900">
                Email
              </label>
              <div className="w-full">
                <input
                  {...register("email", { required: true, validate: (value ) => { return validateEmail(value) } })}
                  type="email"
                  autoComplete="email"
                  required
                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                    ${
                      errors?.email?.type === "required" ?
                      " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                    }
                    `}
                />
                {errors?.email?.type === "required" && (
                  <p className="text-red-500 text-xs ms-2">
                    Email é obrigatório
                  </p>
                )}
                {errors?.email?.type === "validate" && (
                  <p className="text-red-500 text-xs ms-2">
                    Digite um email válido
                  </p>
                )}
              </div>
            </div>

            <div className="flex items-center justify-between gap-2">
              <label className="w-1/4 block text-sm font-medium text-gray-900">
                Telefone
              </label>
              <div className="w-full">
                <input
                  {...register("phone", { required: true })}
                  type="text"
                  required
                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                    ${
                      errors?.phone?.type === "required" ?
                      " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                    }
                    `}
                />
                {errors?.phone?.type === "required" && (
                  <p className="text-red-500 text-xs ms-2">
                    Telefone é obrigatório
                  </p>
                )}
              </div>
            </div>

            <div className="flex items-center justify-between gap-2">
              <label className="w-1/4 block text-sm font-medium text-gray-900 whitespace-nowrap">
                RE / LEGAL
              </label>
              <div className="w-full">
                <input
                  {...register("reLegal")}
                  type="text"
                  required
                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                    ${
                      errors?.reLegal?.type === "required" ?
                      " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                    }
                    `}
                />
              </div>
            </div>

            <div className="flex items-center justify-between gap-2">
              <label className="w-1/4 block text-sm font-medium text-gray-900">
                Estado:
              </label>
              <div className="w-full">
                <select
                  defaultValue="0"
                  {...register("uf", { validate: (value) => { return value !== "0";},})}
                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                  ${
                    errors?.uf?.type === "validate" ?
                    " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                  }
                  `}
                >
                  <option value="0" disabled>
                    Escolha um estado
                  </option>
                  {Estados.map((estado, index) => (
                    <option key={index} value={estado.sigla}>
                      {estado.nome}
                    </option>
                  ))}
                </select>
                {errors?.uf?.type === "validate" && (
                  <p className="text-red-500 text-xs ms-2">
                    Estado é obrigatório
                  </p>
                )}
              </div>
            </div>

            <div className="flex items-center justify-between gap-2">
              <label className="w-1/4 block text-sm font-medium text-gray-900">
                Senha:
              </label>
              <div className="w-full">
                <input
                  {...register("password", { required: true, minLength: 3 })}
                  type="password"
                  required
                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                    ${
                      errors?.password?.type === "required" ?
                      " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                    }
                    `}
                />
                {errors?.password?.type === "required" && (
                  <p className="text-red-500 text-xs ms-2">
                    Senha é obrigatório
                  </p>
                )}
                {errors?.password?.type === "minLength" && (
                  <p className="text-red-500 text-xs ms-2">
                    Senha de ter um mín de 3 caracteres
                  </p>
                )}
              </div>
            </div>

            <div className="flex items-center justify-between gap-2">
              <label className="w-1/4 block text-sm font-medium text-gray-900">
                Confirmar Senha
              </label>
              <div className="w-full">
                <input
                  {...register("confirmpassword", { required: true, validate: (value) =>  value === watchPassword  })}
                  type="password"
                  required
                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                    ${
                      errors?.confirmpassword?.type === "required" ?
                      " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                    }
                    `}
                />
                {errors?.confirmpassword?.type === "required" && (
                  <p className="text-red-500 text-xs ms-2">
                    Confirmar Senha é obrigatório
                  </p>
                )}
                {errors?.confirmpassword?.type === "validate" && (
                  <p className="text-red-500 text-xs ms-2">
                    As senhas não conferem
                  </p>
                )}
              </div>
            </div>

            <div className="flex items-center justify-between gap-2">
              <label className="w-1/4 block text-sm font-medium text-gray-900">
                Perfil:
              </label>
              <div className="w-full">
                <select 
                  defaultValue="user" 
                  {...register("role")}
                  className="block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                >
                  <option value="user">Usuário</option>
                  <option value="tecnico">Técnico</option>
                  <option value="warehouse">Warehouse</option>
                  <option value="vivogestao">Vivo Gestão</option>
                  <option value="entregador">Entregador</option>
                  <option value="report-reader">Visualizador de Relatórios</option>
                </select>
              </div>
            </div>

            <div className="flex items-center justify-between gap-2">
              <label className="w-1/4 block text-sm font-medium text-gray-900 whitespace-nowrap">
                Empresa:
              </label>
              <div className="w-full">
                <select 
                  defaultValue="0"
                  {...register("company")}
                  className="block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                >
                  <option value="0" disabled>Escolha uma empresa</option>
                  {companiesList.map((company) => (
                    <option key={company._id} value={company._id}>
                      {company.socialName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            

          </div>
          <div className="w-full flex flex-col gap-3 justify-center items-center my-6">
              <button
                onClick={() => handleSubmit(onSubmit)()}
                className="flex w-80 justify-center rounded-2xl bg-indigo-600 px-3 py-1 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Cadastrar Usuário
              </button>
              <button
                onClick={() => navigate("/login")}
                className="flex w-80 justify-center rounded-2xl bg-indigo-400 px-3 py-1 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Login
              </button>
            </div>
        </div>
      
        </div>
        {/* RIGHT */}
        <div className="w-full flex justify-start items-center px-20">
          
            <img
              className="min-h-72 object-contain"
              src={visionLogo}
              alt="Logo"
            />
          
        </div>
      </div>
      
      {/* FOOTER */}
       <div className="flex flex-col items-center w-full gap-2 py-4">
         <div>
           <img
            className="mx-auto h-4 w-auto"
            src={amerinodeLogo}
            alt="Your Company"
          />
        </div>
        <div className=" text-xs">
          Brasil • EUA • Argentina • Peru • Equador • Colômbia • México • Chile
        </div>
      </div>
    
    </div>
  </>
  );
}

export default Register;
